import { Component } from '@angular/core';
import { NavController, NavParams,LoadingController } from 'ionic-angular';
import {WarehouseServiceProvider} from '../../../providers/wh/warehouse-service';

@Component({
  selector: 'page-list',
  templateUrl: 'index.html',
  providers: [WarehouseServiceProvider]
})
export class ParcelDetailPage {
 header_data:any;

  public parcel_data: any;
 public  status: any;
 public  parcel_info: any;
  constructor(public navCtrl: NavController, public navParams: NavParams,public warehouseService: WarehouseServiceProvider,public loadingCtrl: LoadingController) {
    this.header_data={ismenu:true,ishome:false,title:navParams.data+" Details"};
       console.log('Driver  Parcels Detail Open');
    console.log(navParams);
    this.load_parcel_details_data(navParams.data)
  }



  load_parcel_details_data(awb)
  {

  let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();



        this.warehouseService.get_parcel_detail(awb)
        .then(data => {
          this.parcel_data = data;
          this.status=this.parcel_data.data.code;
          this.parcel_info=this.parcel_data.data.shipments[0];

        });
        loader.dismiss();
  }



}



// WEBPACK FOOTER //
// ./src/pages/wh/parcel_detail/index.ts